import { connect } from "react-redux";
import ErrorPage from "../../components/errorPage/ErrorPage";

// Which part of the Redux global state does our component want to receive as props?
const mapStateToProps = () => {
  return {};
};

export default connect(mapStateToProps)(ErrorPage);
